<template>
  <div v-cloak>
    <login-panel>
      <div slot="title">Log in</div>
      <div slot="body">
        <transition name="fade">
          <alert v-if="showAlert"></alert>
        </transition>
        <validation-observer
          class="form-horizontal"
          :style="marginTopStyle"
          ref="validationObserver"
          role="form"
          tag="form"
          v-slot="{ invalid }"
        >
          <div class="form-group">
            <label for="inputEmail" class="col-sm-3 control-label">Email</label>
            <validation-provider
              class="col-sm-9"
              mode="eager"
              rules="required|email"
              tag="div"
              v-slot="{ errors }"
            >
              <input
                type="email"
                class="form-control"
                id="inputEmail"
                v-model="username"
                value=""
                placeholder="Email"
                name="email"
                autofocus
                autocomplete="off"
              />
              <span class="text-danger field-validation-error">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="form-group">
            <label for="inputPassword" class="col-sm-3 control-label">Password</label>
            <validation-provider
              class="col-sm-9"
              mode="eager"
              rules="required|min:8"
              v-slot="{ errors }"
            >
              <input
                type="password"
                class="form-control"
                id="inputPassword"
                v-model="password"
                placeholder="Password"
                name="password"
                required
                autocomplete="off"
              />
              <span class="text-danger field-validation-error">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="form-group last">
            <div class="col-sm-offset-3 col-sm-9">
              <button
                class="btn btn-runReport btn-xs"
                v-on:click.prevent="login"
                v-bind:disabled="invalid || isAttemptingLogin"
                type="submit"
              >
                <i class="fas fa-sign-in-alt"></i> Log in
              </button>
            </div>
          </div>
        </validation-observer>
      </div>
      <div slot="footer">
        <p>
          <router-link to="/forgot-password">Forgot your password?</router-link>
        </p>
      </div>
    </login-panel>
  </div>
</template>

<script>
import Axios from '@/packages/axios/Axios';
import { AxiosConfig, AppConfig } from '@/config/config';

import { mapGetters, mapMutations } from 'vuex';

import Alert from '@/components/alerts/Alert';
import LoginPanel from '@/components/login/LoginPanel';

export default {
  components: {
    Alert,
    LoginPanel,
  },
  computed: {
    ...mapGetters(['current_user', 'messages']),
    marginTopStyle() {
      if (this.showAlert) {
        return 'margin-top: 1rem;';
      }
      return '';
    },
  },
  created() {
    if (process.env.NODE_ENV === 'development') {
      this.username = AppConfig.testUser;
      this.password = AppConfig.testPassword;
    }
  },
  data() {
    return {
      response: [],
      errors: [],
      username: '',
      password: '',
      isAttemptingLogin: false,
      alerts: [],
      showAlert: false,
    };
  },
  methods: {
    ...mapMutations(['pop_message', 'push_message']),
    login() {
      this.$store.commit('SHOW_PLEASE_WAIT');
      Axios.post('/oauth/token', {
        grant_type: 'password',
        username: this.username,
        password: this.password,
        scope: '*',
        client_id: AxiosConfig.clientId,
        client_secret: AxiosConfig.clientSecret,
      })
        .then(async (response) => {
          if (response.status === 200) {
            this.$auth.set_token(response.data);
            await this.$store.dispatch('authenticated');
            // console.log("login() - After dispatch('authenticated')...");
            /*
             * TODO This seems to not work at first...
             * It seems the user needs to click twice on the login button
             * which is odd, considering that dispatch('authenticated')
             * calls the 'await' dispatch('fetch_user') function...
             */

            if (this.current_user) {
              if (this.current_user.requires_password_change) {
                // console.log('Going to /change-password');
                this.$router.push('/change-password');
              } else if (this.$route.query.b !== undefined) {
                // console.log(`Going to ${this.$route.query.b}`);
                this.$router.push(this.$route.query.b);
              } else {
                // console.log('Going to /reports/create');
                this.$router.push('/reports/create').catch(()=>{});
              }
            } else {
              this.$router.push('/reports/create').catch(()=>{});
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$store.commit('push_message', {
              title: 'Invalid credentials',
              body:
                '<p>Sorry, the details supplied are incorrect.</p>',
              type: 'danger',
            });
            this.showAlert = true;
            setTimeout(() => {
              this.showAlert = false;
            }, 10000);
          } else {
            this.$store.commit('push_message', {
              title: 'Cannot login',
              body:
                'The authentication server is not responding and so '
                + 'we cannot log you in. Please try again in about 10 '
                + 'minutes. Our support team has been made aware of the '
                + 'outage and are working to get the authentication server '
                + 'up and running again.',
              type: 'danger',
            });
            this.showAlert = true;
          }
          this.$store.commit('HIDE_PLEASE_WAIT');
          this.errors.push(error);
        });
    },
    remove_message() {
      if (this.messages.length > 0) this.pop_message();
    },
  },
  watch: {
    email(newValue, oldValue) {
      if (this.password.length >= 8 && newValue.length > 0) {
        this.$nextTick(() => {
          this.$refs.validationObserver.validate();
        });
      }
    },
    password(newValue, oldValue) {
      if (this.username.length > 0 && newValue.length >= 8) {
        this.$nextTick(() => {
          this.$refs.validationObserver.validate();
        });
      }
    },
  },
};
</script>

<style>
</style>
